export default {
  notifyParentIframe: function (routeParams) {
    if (window.parent !== window) {
      window.parent.postMessage({
        type: 'vyopta-navigation',
        hash: '#' + routeParams.request_,
        route: routeParams
      }, '*');
    }
  },
  notifyParentIframeBreadcrumbs: function (breadcrumbs) {
    if (window.parent !== window.self) {
      window.parent.postMessage({
        type: 'vyopta-breadcrumbs',
        breadcrumbs: breadcrumbs
      }, '*');
    }
  },
};
